$( () => {

    const header = {
        'canvasMenu'  : document.getElementById('mobile-menu'),
        init() {
            // const canvasMenu = ;
            // $(document).on('click', '.language-toggle', this, this.toggleLanguage);
            $(document).on('click', '.hamburger', this, this.toggleMenu);
            // $(document).on('click', '.has-submenu', this, this.toggleSubMenu);
            header.canvasMenu.addEventListener('hide.bs.offcanvas', () => {
                header.toggleMenu();
            });
        },
        // toggleLanguage(event) {
        //     event.preventDefault();

        //     const $this = $(this);
        //     const _this = event.data;
        //     $this.siblings().slideToggle();

        // },
        toggleMenu() {
            // event.preventDefault();
            // const $this = $(this);
            // const _this = event.data;
            $('.hamburger').toggleClass('is-active');

        },
        // toggleSubMenu(e) {
        //     e.preventDefault();
        //     const $this = $(this);
        //     const _this = e.data;
        //     $this.siblings('.sidebar-submenu').toggleClass('active');

        // },

    };

    if ($('header').length) {
        header.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/header.js